var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showmsg)?_c('div',{class:'message__' + _vm.type},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showClose),expression:"showClose"}],staticClass:"message__close",on:{"click":_vm.clicMsg}}),_c('div',{class:'message__text ' + _vm.align},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }